module.exports = __webpack_public_path__ + "img/test_before_ai.c57a4ad6.jpg";